import VideoSessionContext from 'contexts/VideoSessionContext';
import { useContext } from 'react';

const useSession = () => {
  const context = useContext(VideoSessionContext);

  if (!context) throw new Error('context must be use inside provider');

  return context;
};

export default useSession;
